import React from 'react';
import { Card } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CHUNGCHI_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import ChungChiForm from './ChungChiForm';
import { useMutation, useQueryClient } from 'react-query';

const schema = yup.object().shape({
    accountId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage),
    trichYeuId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage),
    fileManagerId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage)
});

const ChungChiAdd = () => {
    const history = useHistory();
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) =>
        Post(CHUNGCHI_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    toast.success(messageToast.messageToastCreateSuccess);
                    queryClient.invalidateQueries('chungChiData');
                    history.push(URI_INTERNAL.CHUNGCHI_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới chứng chỉ</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        accountId: '',
                        trichYeuId: '',
                        fileManagerId: '',
                        description: ''
                    }}
                >
                    {(formik) => (
                        <ChungChiForm formik={formik} isSaving={addFunc.isLoading} isEdit={false} />
                    )}
                </Formik>
                {addFunc.isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default ChungChiAdd;
